<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagementlog}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="pipeLine()">
        <el-form-item>
          <renSelect v-model="dataForm.operatingObjects" dictType="action" placeholder="操作对象"></renSelect>
        </el-form-item>
        <el-form-item>
          <renSelect v-model="dataForm.operatingActions" dictType="operator" placeholder="操作动作"></renSelect>
        </el-form-item>
        <el-form-item label="">
          <wPickers v-model="dateValue" @input="getTimes"></wPickers>
        </el-form-item>
        <el-form-item >
          <el-select v-model="dataForm.operators" clearable placeholder="操作人">
            <el-option v-for="item in userList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
       
        <el-form-item>
          <el-button @click="pipeLine()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:accessmanagementlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:accessmanagementlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle($event,false)" style="width: 100%;">
      
        <el-table-column prop="operationTime" label="操作时间"  sortable="custom"  header-align="center" align="center"></el-table-column>
        <el-table-column prop="operatorsName" label="操作人"   header-align="center" align="center"></el-table-column>
        <el-table-column prop="operatingObjects" label="操作对象"  sortable="custom"  header-align="center" align="center"></el-table-column>
        <el-table-column prop="operatingActions" label="操作动作"  sortable="custom"  header-align="center" align="center"></el-table-column>
        <el-table-column label="操作结果" prop="operatingContent" header-align="center"  sortable="custom" align="center">
          <template slot-scope="scope">
            <div class="operatingActions">
              {{ scope.row.oldOperating + '-' + scope.row.operatingContent }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operatingIp" label="操作IP"  sortable="custom"  header-align="center" align="center"></el-table-column>
      
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/operatinglog/page',
        getDataListIsPage: true,
        exportURL: '/sys/operatinglog/export',
        deleteURL: '/sys/operatinglog',
        deleteIsBatch: true
      },
      dateValue: '',
      userList: [],
      dataForm: {
        // id: '1670003512831963138',
        id: '',
        startDate: '',
        endDate: '',
        operatingObjects: '',
        operatingActions: '',
        operators: '',
      }
    }
  },
  watch: {
    $route: {
      handler(val){
        console.log(val)
        if(val.query.id){
          this.dataForm.id = val.query.id
          this.getDataList();
        }else{
          this.dataForm.id = ''
        }
      },
      immediate: true,
      // this.getDataList();
    },
  },
  mounted(){
    this.getSelectList()
  },

  methods: {
    getTimes() {
       
        if (this.dateValue != null) {
          this.dataForm.startDate = this.dateValue[0]
          this.dataForm.endDate = this.dateValue[1]
        }else{
          this.dataForm.startDate = ''
          this.dataForm.endDate = ''
        }
      },
      pipeLine(){
        this.dataForm.id = ''
       this.getDataList()
      },
      getSelectList(){
        this.$http.post('/sys/operatinglog/getUserList').then(({data: res}) => {
          if(res.code != 0){
            this.$message.error(res.msg)
          }
         this.userList = res.data.map(item => {
            return {
              value: item.id,
              label: item.realName,
            }
          })
        })
      }
  },
  components: {
  
  }
}
</script>
<style>
.operatingActions{
  height: 200px;
  overflow: auto;
}
</style>
